import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';

export default function Filters({
  keyword,
  setKeyword,
  status,
  setStatus,
}) {
  const statuses = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Active',
      value: 'active',
    },
    {
      label: 'Archived',
      value: 'deleted',
    },
  ];

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Col>

        <Col md={3}>
          <Select
            onChange={(option) => {
              setStatus(option.value);
            }}
            value={statuses.find((item) => item.value === status)}
            options={statuses}
          />
        </Col>

      </Row>
    </div>
  );
}
